import React from "react"
import { useTranslation } from "react-i18next"

import { Link } from "~/components/Link/Link"
import { LinksBundle } from "~/components/LinksBundle/LinksBundle"
import { Raw } from "~/components/raw"

import styles from "./index.module.css"

export const ContentBlueForm: React.FC = () => {
  const { t } = useTranslation()

  return (
    <>
      <div>
        <LinksBundle>
          <Link href="/about/corpmanage/komitet-po-auditu-finansam-i-riskam" view="arrow">
            <Raw html={t("stockholders-meeting.BlueForm.Content.Link.01")} />
          </Link>
          <Link
            href="https://online.aoreestr.ru/login"
            rel="noopener noreferrer"
            target="_blank"
            view="arrow"
          >
            <Raw html={t("stockholders-meeting.BlueForm.Content.Link.02")} />
          </Link>
        </LinksBundle>

        <a className={styles.Email} href="mailto:ir_committee@sistema.ru">
          ir_committee@sistema.ru
        </a>
      </div>
      <div className="d-none d-sm-block" />
    </>
  )
}
